import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
import { addSurveyData, addSurveyDataFailure, addSurveyDataSuccess, cancelSurveyRecord, cancelSurveyRecordFailure, cancelSurveyRecordSuccess, createHoldRecord, createHoldRecordFailure, createHoldRecordSuccess, createSurveyCommentRecord, createSurveyCommentRecordFailure, createSurveyCommentRecordSuccess, editSurveyData, editSurveyDataFailure, editSurveyDataSuccess, fetchSurveyAttachments, fetchSurveyAttachmentsFailure, fetchSurveyAttachmentsSuccess, fetchSurveyCancelReasonsList, fetchSurveyCancelReasonsListFailure, fetchSurveyCancelReasonsListSuccess, fetchSurveyFileAttachment, fetchSurveyFileAttachmentFailure, fetchSurveyFileAttachmentSuccess, fetchSurveyListData, fetchSurveyListFailure, fetchSurveyListSuccess, fetchSurveyMembersList, fetchSurveyMembersListFailure, fetchSurveyMembersListSuccess, fetchSurveyRecordComments, fetchSurveyRecordCommentsFailure, fetchSurveyRecordCommentsSuccess, fetchSurveyRecordholdunhold, fetchSurveyRecordholdunholdFailure, fetchSurveyRecordholdunholdSuccess, fetchSingleSurveyRecordData, fetchSingleSurveyRecordDataFailure, fetchSingleSurveyRecordDataSuccess, releaseSurveyRecord, releaseSurveyRecordFailure, releaseSurveyRecordSuccess, updateSurveyStatus, updateSurveyStatusFailure, updateSurveyStatusSuccess } from "./survey.actions";
import { catchError, from, map, mergeMap, of, switchMap, tap } from "rxjs";
import { TokenStorageService } from "../../core/services/token-storage.service";
import { GenericService } from "../../core/services/generic.service";
import { and, collection, collectionData, or, orderBy, query, QueryCompositeFilterConstraint, where } from "@angular/fire/firestore";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { SurveyModel } from "../../core/models/survey.models";
import { SurveyService } from "../../core/services/survey.service";
import { CommonAPIService } from "../../core/services/common-api.service";
import { ToastifyService } from "../../shared/toastify-service";
import { GlobalComponent } from "../../global-component";
import { FiltersService } from "../../core/services/filters.service";

@Injectable()
export class SurveyEffects{
    currentuser: any;
    firbasebasecollname: string = 'vendors';
    subdomaincollname: string = 'subdomains';
    vendorguid!: string;
    issurveyor = false;

    constructor(
        private actions$: Actions, 
        private tokenService: TokenStorageService,
        private genericService: GenericService,
        private afs: AngularFirestore,
        private surveyservice: SurveyService,
        private commonService: CommonAPIService,
        private toastifyService: ToastifyService,
        private filtersService: FiltersService
    ) {}

    // check condition
    async checkCondition(tabId: number) {
        console.log("--inside check condition--", tabId);
        this.currentuser = this.tokenService.getUser();
        this.issurveyor = this.currentuser.issurveyor;
        console.log("--current user inside check condition--", this.currentuser)
        const isuservendor = this.genericService.getUserIsVendor();
        const vendorCollection = collection(this.afs.firestore, `${this.firbasebasecollname}/${this.tokenService.getVendorGUID()!}/surveys`);
        console.log("---vendorCollection Line 30---", vendorCollection);
        let activestateval = true;
        if (tabId == 5) {
            activestateval = false;
        }

        let baseQuery = and(where('activestate', '==', activestateval));

        const filterData: any = this.filtersService.getSurveySelectedFilters()

        // Adding Filter Queries to baseQuery
    if (filterData.clients && filterData.clients.length) {
        baseQuery = and(baseQuery, where("clientguid", 'in', filterData.clients))
        }
        
        if (filterData.states && filterData.states.length) {
            baseQuery = and(baseQuery, where("state", "in", filterData.states))
        }
        
        
        if (filterData.statuses && filterData.statuses.length) {
            baseQuery = and(baseQuery, where("jobstatus", "in", filterData.statuses))
        }
        
        if (filterData.daterange && filterData.daterange.length) {
            let queryby = ""
            switch (tabId) {
              case 1:
                queryby = "createdAt"
                break
              case 2:
                queryby = "onholddate"
                break
              case 4:
                queryby = "deliverydate"
                break
              default:
                queryby = "createdAt"
            }
            let startDate = new Date(filterData.daterange[0].setHours(0, 0, 0, 0))
            let endDate = new Date(filterData.daterange[0].setHours(23, 59, 59, 999))
            console.log(startDate, endDate)
            if (filterData.daterange.length === 2) {
              endDate = new Date(filterData.daterange[1].setHours(23, 59, 59, 999))
            }
      
            baseQuery = and(baseQuery, where(queryby, ">=", startDate.toISOString()), where(queryby, "<=", endDate.toISOString()))
          }
      



        const userRoleCondition = where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
        let userRoleQuery: any = baseQuery;
        let memberQuery: QueryCompositeFilterConstraint | null = null;

        console.log("condition test 1", !this.currentuser.usertype || !isuservendor, isuservendor, this.currentuser)
        if (!this.currentuser.usertype || !isuservendor) {
            userRoleQuery = and(userRoleCondition, where('activestate', '==', activestateval)) as QueryCompositeFilterConstraint;
        }

        console.log("condition test 2", this.currentuser.guid, activestateval, tabId)

        switch (tabId) {
            case 1:
                if (!isuservendor) {
                    return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked'])), orderBy("createdAt", "desc"));
                }

                if(this.currentuser.issurveyor){
                    return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['accepted'])), orderBy("createdAt", "desc"));
                }

                return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['outsourced', 'accepted', 'picked'])), orderBy("createdAt", "desc"));

            case 2:
                return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['hold'])), orderBy("onholddate", "desc"));

            case 3:
                if (this.currentuser.issurveyor) {
                    return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['surveyinprogress', 'surveyrejected']), where('activeuserguid', '==', this.currentuser.guid)), orderBy("createdAt", "desc"));
                }

              
                

                return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['surveyinprogress', 'surveyrejected'])), orderBy("createdAt", "desc"));
                
            

            case 4:
                // Delivered list - To be done - indexing required - activeuserguid will be changed to respective userguid
                // if (this.currentuser.issurveyor) {
                //     return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'delivered'), where('isarchived', '==', false), where('activeuserguid', '==', this.currentuser.guid))), orderBy("deliverydate", "desc"));
                // }
                return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'delivered'), where('isarchived', '==', false))), orderBy("deliverydate", "desc"));

            case 5:
                return query(vendorCollection, userRoleQuery, orderBy("cancelleddate", "desc"));

            default:
                console.log('Invalid tabId:', tabId);
                return query(vendorCollection, baseQuery, orderBy("createdAt", "desc"));
        }
    }

    // Survey List Effect Of Vendor
    // {
    // const collectionRef = collection(this.afs.firestore, `surveys/${tabId}/data`);
    // return collectionData<SurveyModel>(collectionRef).pipe(
    //     map((docs) => {
    //         console.log("docs", docs);
    //         console.log("tabId", tabId);
    //         return fetchSurveyListSuccess({ Survey: docs, tabId });
    //     }),
    //     catchError((error) =>
    //         of(fetchSurveyListFailure({ error: error.message, tabId }))
    //     )
    // );
    // }

    // Create Survey Record
    addSurveyData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addSurveyData),
            mergeMap(({ postdata }) =>
                this.surveyservice.addSurveyData(postdata).pipe(
                    map((Surveyrecord) => addSurveyDataSuccess(Surveyrecord)),
                    catchError((error) => of(addSurveyDataFailure({ error })))
                )
            ),
        ),
    );

    addSurveyDataSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addSurveyDataSuccess),
                tap((user: any) => {
                    this.toastifyService.showSuccessMessage("Order created successfully");
                })
            ),
        { dispatch: false }
    );

    addSurveyDataFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addSurveyDataFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // // Fetching surveys from firebase
    // fetchSurveyData$ = createEffect(() =>
    //     this.actions$.pipe(
    //       ofType(fetchSurveyListData),
    //       mergeMap(({ tabId }) =>
    //         from(this.checkCondition(tabId)).pipe(
    //           mergeMap(condition =>
    //             collectionData(condition).pipe(
    //               map((docs: any) => {
    //                 console.log("docs", docs);
    //                 console.log("tabId", tabId);
    //                 const surveys = docs.map((doc: SurveyModel) => doc);
    //                 return fetchSurveyListSuccess({ Surveys: surveys, tabid: tabId });
    //               }),
    //               catchError((error) =>
    //                 of(fetchSurveyListFailure({ error, tabid: tabId }))
    //               )
    //             )
    //           )
    //         )
    //       )
    //     )
    //   );

    // Refetch when the condition changes
fetchSurveyData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSurveyListData),
      switchMap(({ tabId }) => 
        from(this.checkCondition(tabId)).pipe(
          switchMap(condition =>
            collectionData(condition).pipe(
              map((docs: any) => fetchSurveyListSuccess({ Surveys: docs, tabid: tabId })),
              catchError((error) => of(fetchSurveyListFailure({ error, tabid: tabId })))
            )
          )
        )
      )
    )
  );

    // Fetching and updating surveys status
    updateSurveyStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateSurveyStatus),
            mergeMap(({ recordguid, postdata }) =>
                this.surveyservice.updateSurveyStatus(recordguid, postdata).pipe(
                    map(() => updateSurveyStatusSuccess()),
                    catchError((error) => of(updateSurveyStatusFailure({ error })))
                )
            ),
        ),
    );

    // Fetch survey record
    fetchSingleSurveyRecordData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleSurveyRecordData),
            mergeMap(({ recordguid }) =>
                this.surveyservice.getSingleSurveyRecordData(recordguid).pipe(
                    map((surveyrecord) => fetchSingleSurveyRecordDataSuccess({ surveyrecord })),
                    catchError((error) => of(fetchSingleSurveyRecordDataFailure({ error })))
                )
            ),
        ),
    );

    // Comment create
    createSurveyCommentRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(createSurveyCommentRecord),
            mergeMap(({ postdata }) =>
                this.commonService.createRecords('surveycomments', postdata).pipe(
                    map((comment) => createSurveyCommentRecordSuccess({ comment })),
                    catchError((error) => of(createSurveyCommentRecordFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Survey Comments Record
    fetchSurveyRecordComments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSurveyRecordComments),
            mergeMap(({ recordguid }) =>
                this.commonService.fetchRecords('surveycomments', recordguid, 'createdAt:DESC').pipe(
                    map((comments) => fetchSurveyRecordCommentsSuccess({ comments: comments })),
                    catchError((error) => of(fetchSurveyRecordCommentsFailure({ error })))
                )
            ),
        ),
    );

    fetchSurveyRecordCommentsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchSurveyRecordCommentsFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // Fetch Survey Comments Record
    fetchSurveyMembersList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSurveyMembersList),
            mergeMap(({ recordguid }) =>
                this.surveyservice.getSurveysMembersList(recordguid).pipe(
                    map((list) => fetchSurveyMembersListSuccess({ memberslist: list })),
                    catchError((error) => of(fetchSurveyMembersListFailure({ error })))
                )
            ),
        ),
    );

    fetchSurveyMembersListFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchSurveyMembersListFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // HOLD RECORD CREATE
    createHoldRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(createHoldRecord),
            mergeMap(({ postdata }) =>
                this.commonService.createRecords('surveyholdjobs', postdata).pipe(
                    map((holdrecord: any) => createHoldRecordSuccess({ holdrecord })),
                    catchError((error) => of(createHoldRecordFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Survey Hold/Unhold Record
    fetchSurveyRecordholdunhold$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSurveyRecordholdunhold),
            mergeMap(({ recordguid }) =>
                this.commonService.fetchRecords('surveyholdjobs', recordguid, 'createdAt:DESC').pipe(
                    map((holdunholdrecords) => fetchSurveyRecordholdunholdSuccess({ holdunhold: holdunholdrecords })),
                    catchError((error) => of(fetchSurveyRecordholdunholdFailure({ error })))
                )
            ),
        ),
    );

    // FETCH ATTACHMENTS OF Survey RECORD
    fetchSurveyAttachments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSurveyAttachments),
            mergeMap(({ jobguid }) =>
                this.surveyservice.getSurveysAttachments(jobguid).pipe(
                    map((attachments) => fetchSurveyAttachmentsSuccess({ attachments })),
                    catchError((error) => of(fetchSurveyAttachmentsFailure({ error })))
                )
            ),
        ),
    );

    fetchSurveyAttachmentsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchSurveyAttachmentsFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // CANCEL SURVEY PROJECT
    cancelSurveyRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(cancelSurveyRecord),
            mergeMap(({ postdata }) =>
                this.surveyservice.cancelSurveyProject(postdata).pipe(
                    map(() => cancelSurveyRecordSuccess()),
                    catchError((error) => of(cancelSurveyRecordFailure({ error })))
                )
            ),
        ),
    );

    cancelSurveyRecordSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(cancelSurveyRecordSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage(GlobalComponent.messages.cancelsuccess);
                })
            ),
        { dispatch: false }
    );

    cancelSurveyRecordFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(cancelSurveyRecordFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // FETCH CANCEL REASONS FROM FIREBASE
    fetchSurveyCancelReasonsList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSurveyCancelReasonsList),
            mergeMap(() =>
                this.afs.collection(GlobalComponent.firebasecancelreasonsbasecollname).doc('JnlKZBhKuN2yOmSiptTb')
                    .valueChanges().pipe(
                        map((docs: any) => {
                            console.log(":docs", docs)
                            return fetchSurveyCancelReasonsListSuccess({ reasons: docs });
                        }),
                        catchError((error) =>
                            of(fetchSurveyCancelReasonsListFailure({ error }))
                        )
                    )
            ),
        ),
    );

    fetchSurveyCancelReasonsListFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchSurveyCancelReasonsListFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
                })
            ),
        { dispatch: false }
    );

    /**
   * RELEASE PLANSET RECORD
   */
    releaseSurveyRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(releaseSurveyRecord),
            mergeMap(({ recordguid, postdata }) =>
                this.surveyservice.releaserecord(recordguid, postdata).pipe(
                    map(() => releaseSurveyRecordSuccess()),
                    catchError((error) => of(releaseSurveyRecordFailure({ error })))
                )
            ),
        ),
    );

    releaseSurveyRecordSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(releaseSurveyRecordSuccess),
                tap(() => {
                    this.toastifyService.showSuccessMessage("Record released successfully");
                    // this.router.navigate(['../']);
                })
            ),
        { dispatch: false }
    );

    releaseSurveyRecordFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(releaseSurveyRecordFailure),
                tap((error: any) => {
                    console.log('error', error);
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // Edit Survey Record
    editSurveyData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(editSurveyData),
            mergeMap(({ postdata, recordId }) =>
                this.surveyservice.editSurveyData(postdata, recordId).pipe(
                    map((Surveyrecord) => editSurveyDataSuccess(Surveyrecord)),
                    catchError((error) => of(editSurveyDataFailure({ error })))
                )
            ),
        ),
    );

    editSurveyDataSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editSurveyDataSuccess),
                tap((user: any) => {
                    this.toastifyService.showSuccessMessage("Order updated successfully");
                })
            ),
        { dispatch: false }
    );

    editSurveyDataFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(editSurveyDataFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // FETCH ATTACHMENTS OF SURVEY RECORD
  fetchSurveyFileAttachment$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchSurveyFileAttachment),
      mergeMap(({ jobguid }) =>
        this.surveyservice.getSurveyFile(jobguid).pipe(
          map((attachments) => fetchSurveyFileAttachmentSuccess({ attachments })),
          catchError((error) => of(fetchSurveyFileAttachmentFailure({ error })))
        )
      ),
    ),
  );

  fetchSurveyFileAttachmentFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fetchSurveyFileAttachmentFailure),
        tap((error: any) => {
          this.toastifyService.showErrorMessage(error.error.message);
        })
      ),
    { dispatch: false }
    );
    




 
}
